import { Carrier } from "../carrier/carrier";
import { ContainerItem } from "../carrier/carrieritem";
import { CarrierType } from '../carrier/carrier-enum';

export class CarrierUtility {


  //Get carrier state
  getStateAsString(carrier: Carrier): string {
    if (carrier !== undefined && carrier !== null && carrier.state !== undefined && carrier.state !== null) {
      if (carrier.state.toString() == "COMPLETE") {
        return 'SC';
      }
      else if (carrier.state.toString() == "WORK_IN_PROGRESS") {
        return 'WIP';
      }
      else if (carrier.state.toString() == "LAB_PROCESSING") {
        return 'LP';
      }
    }
    else {
      return "";
    }
  }


  //Sample volume validation
  volumeOk(i: number, j: number, item: Carrier): boolean {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return true;
    }

    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem !== null && currentItem.containerItemAware !== undefined && currentItem.containerItemAware !== null) {
      let sample: any = currentItem.containerItemAware;
      if (sample.latestMeasuredVolume.value !== undefined && sample.latestMeasuredVolume.value !== null && sample.targetVolume !== 0) {
        return sample.latestMeasuredVolume.value <= sample.targetVolume;
      }
    }
    return true;
  }

  //Barcode validation
  barcodeFound(i: number, j: number, item: Carrier): boolean {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return true;
    }

    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem !== null && currentItem.containerItemError !== undefined && currentItem.containerItemError !== null && currentItem.containerItemError.code == 'error.sample.for.barcode.not.found') {
      return false;
    }
    return true;
  }

  //Get CarrierItem barcode
  getCarrierItemBarcode(i: number, j: number, item: Carrier): string {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return null;
    }

    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem !== null) {
      return currentItem.barcode;
    }
    return null;
  }


  //Get CarrierItem error barcode
  getCarrierItemErrorBarcode(i: number, j: number, item: Carrier): string {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return null;
    }

    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem !== null && currentItem.containerItemError != null && currentItem.containerItemError != undefined) {
      return currentItem.containerItemError.code;
    }
    return null;
  }






  //Get the primer name
  getCarrierItemPrimerName(i: number, j: number, item: Carrier): string {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return null;
    }

    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem !== null && currentItem !== undefined && currentItem.containerItemAware != null && currentItem.containerItemAware != undefined && currentItem.containerItemAware.primerName != null && currentItem.containerItemAware.primerName != undefined) {
      return currentItem.containerItemAware.primerName;

    }
    return null;
  }

  //Get Carrier item volume
  getCarrierItemVolume(i: number, j: number, item: Carrier): string {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return '-';
    }

    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem !== null && currentItem.containerItemAware !== null) {
      return currentItem.containerItemAware.latestMeasuredVolume.value;
    }
    return '-';
  }


  //Get Carrier item target volume
  getCarrierItemTargetVolume(i: number, j: number, item: Carrier): any {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return '-';
    }

    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem !== null && currentItem.containerItemAware !== null && currentItem.containerItemAware.targetVolume !== null) {
      return currentItem.containerItemAware.targetVolume;
    }
    return '-';
  }

  //Get target volume change check
  getTargetVolumeChangeTag(i: number, j: number, item: Carrier): boolean {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return false;
    }

    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem !== null && currentItem.containerItemAware !== null && currentItem.containerItemAware.volumeChanged !== null) {
      return currentItem.containerItemAware.volumeChanged;
    }
    return false;
  }



  //Get sample concentration value
  getCarrierItemSampleConcentration(i: number, j: number, item: Carrier): any {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return '-';
    }
    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem !== null && currentItem.containerItemAware !== null
      && currentItem.containerItemAware.latestMeasuredConcentration == null) {
      return 'NA';
    }


    if (currentItem !== null && currentItem.containerItemAware !== null
      && currentItem.containerItemAware.latestMeasuredConcentration != undefined
      && currentItem.containerItemAware.latestMeasuredConcentration != null) {

      if (currentItem.containerItemAware.latestMeasuredConcentration.value == 0) {
        return '-';
      }
      if (currentItem.containerItemAware.latestMeasuredConcentration.value === -1) {
        return '?????';
      }
      if (currentItem.containerItemAware.latestMeasuredConcentration.value === -9999999) {
        return '<0,000';
      }
      // Backend returns Float.MAX_VALUE. That comparison here should be ok.
      if (currentItem.containerItemAware.latestMeasuredConcentration.value === 9999999) {
        return '>105,000';
      }
      return this.roundOfDecimal(currentItem.containerItemAware.latestMeasuredConcentration.value);
    }
    return '-';
  }


  //Get carrierItem for index
  getCarrierItemForIndex(selectedCarrier: Carrier, i: number, j: number): ContainerItem {
    if (selectedCarrier.containerItems != null)
      for (var y = 0; y < selectedCarrier.containerItems.length; y++) {
        let currentItem: ContainerItem = selectedCarrier.containerItems[y];

        if (currentItem.positionCol == j + 1 && currentItem.positionRow == i + 1) {
          return currentItem;
        }
      }
    return null;
  }


  //Get Carrier type
  getCarrierTypeAsString(carrier: Carrier): string {
    if (carrier !== undefined && carrier !== null && carrier.carrierType !== undefined && carrier.carrierType !== null) {
      if (carrier.carrierType.toString() == "TUBE_CARRIER") {
        return 'LightRun Tubes';
      }
      else if (carrier.materialType == null && carrier.carrierType.toString() == "PLATE_CARRIER") {
        return 'LightRun Plates';
      }
      else if (carrier.carrierType.toString() == "Mix2Seq") {
        return 'Mix2Seq';
      }
      else if (carrier.carrierType.toString() == "TUBE_RACK") {
        return 'Primer Tube Rack';
      }
      else if (carrier.materialType != null && carrier.carrierType.toString() == "PLATE_CARRIER") {
        return "Primer Plate Carrier"
      }
      else if (carrier.carrierType == CarrierType.SR_TUBE_CARRIER || carrier.carrierType == CarrierType.PURIFIED_DNA) {
        return "SR Tube";
      }
      else if (carrier.carrierType == CarrierType.UNPURIFIED_PCR) {
        return "Unpurified DNA";
      }
      else if (carrier.carrierType == CarrierType.CLONE) {
        return "Clone";
      }
      else if (carrier.carrierType == CarrierType.HAMILTON_CARRIER) {
        return "HAMILTON CARRIER";
      } else if (carrier.carrierType == "PREMIXED_DNA") {
        return "PREMIXED_DNA"
      }
    }
    else {
      return "";
    }
  }

  //Check is Sample is active
  isSampleActive(i: number, j: number, item: Carrier): boolean {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return true;
    }

    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem !== null && currentItem.containerItemAware !== undefined && currentItem.containerItemAware !== null) {
      let sample: any = currentItem.containerItemAware;
      return sample.active;
    }
    return true;
  }

  //Get sample's assay type
  getSampleAssayType(i: number, j: number, item: Carrier): string {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return '-';
    }
    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem !== null && currentItem.containerItemAware !== null &&
      currentItem.containerItemAware.libtypes != undefined &&
      currentItem.containerItemAware.libtypes.entryQcFAAssayType != null) {
      return currentItem.containerItemAware.libtypes.entryQcFAAssayType;
    }
  }


  //Get sample's concentrationMeasurementRequired value
  isConcentrationMeasurementRequired(i: number, j: number, item: Carrier): string {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return '-';
    }
    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);

    if (currentItem !== null && currentItem.containerItemAware !== null &&
      currentItem.containerItemAware.concentrationMeasurementRequired != undefined &&
      currentItem.containerItemAware.concentrationMeasurementRequired != null) {
      return currentItem.containerItemAware.concentrationMeasurementRequired;
    }
  }

  //Method to round of decimal digits of measured volume
  roundOfDecimal(num: any) {
    if (num != null)
      return Math.round(num * 100) / 100
  }

  getCarrierItemBuffer(i: number, j: number, item: Carrier) {
    let selectedCarrier: Carrier = item;
    if (selectedCarrier === null) {
      return '-';
    }

    let currentItem: ContainerItem = this.getCarrierItemForIndex(selectedCarrier, i, j);
    if (currentItem !== null && currentItem.containerItemAware !== null &&
      (currentItem.containerItemAware.libtypes !== null || currentItem.containerItemAware.libtypes !== undefined) &&
      (currentItem.containerItemAware.libtypes.buffer !== null || currentItem.containerItemAware.libtypes.buffer !== undefined)) {
      return currentItem.containerItemAware.libtypes.buffer;
    }

    return '-';

  }

}
